import React, { Component } from 'react';
import "./maevelife.css";
import Logo from "../images/Maevelifestyle/logo.png"
import HeaderLogin from "../headerComponents/headerLogin"
import User from "../images/Maevelifestyle/profile-user.png"
import cart from "../images/Maevelifestyle/grocery-store.png"
import HeaderLocation from "../headerComponents/headerLocationSeller"
import Cart from "../headerComponents/cartLokal"
import $ from "jquery";
import HeaderLocationNameSeller from "../headerComponents/headerLocationNameSeller"
export default class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cartVisible: false
        };
        this.cartClick = this.cartClick.bind(this);


    }
    componentDidMount() {   
        let locationId = localStorage.getItem('locationId');
        if (locationId === null) {
          $(".locationPopUp").show();
          $("#locationDiv").addClass("locationOpenPopUp")
        }
        else {
          $(".locationPopUp").hide();
          $("#locationDiv").removeClass("locationOpenPopUp")
        }     
        $(".popOverlay").click(function () {
            $(".popupWrap").hide();
        });        
        $(".loginClose").click(function () {
            $(".popupWrap").hide();
        });        
    }
    cartClick() {
        if (document.getElementById("globalSearchDiv") !== null) {
            document.getElementById("globalSearchDiv").style.display = "none";
        }
        if (!this.state.cartVisible) {
            document.addEventListener('click', this.cartOutsideClick, false);
        } else {
            document.removeEventListener('click', this.cartOutsideClick, false);
        }
        this.setState(prevState => ({
            cartVisible: !prevState.cartVisible,
        }));
    }
    homeClick(){
        let themeId = localStorage.getItem('themeId')
        if(themeId == '2'){
            window.location.href = "/";
        }
    }
    render() {
        let cartLength = 0;
        if (localStorage.getItem('selectedCartProduct') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectedCartProduct')).length);
        }
        if (localStorage.getItem('selectRestaurantCart') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectRestaurantCart')).length);
        }
        if (localStorage.getItem('selectCommonItemCart') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectCommonItemCart')).length);
        }
        return (
            <div className="container header-main">
                <div className="header-outer">
                <div className='header'>
                    <div className='row align-items-center m-0'>
                        <div className='col-6 col-lg-9 col-md-9' onClick={this.homeClick}>
                            <img src={Logo} alt="Logo" className='img-fluid ml-5 header-logo' width="110" height="110"/>
                        </div>
                        <div className='col-6 col-md-3 col-lg-3'>
                       
                            <div className="d-flex">
                            <span class="cartIcon av_locationIcon mr-2"> <HeaderLocation></HeaderLocation></span>  
                            <HeaderLogin></HeaderLogin>
                                <>
                                
                                <div className='position-relative'>
                                <img src={cart} onClick={this.cartClick} alt="Cart" className='img-fluid cursor-pointer' width="32" height="32"/>
                                <span className="cartCount" onClick={this.cartClick} id="cartCount">{cartLength}</span>
                                </div> 
                                </>
                            </div>
                            <span class="cartIcon"><HeaderLocationNameSeller></HeaderLocationNameSeller></span>
                        </div>
                    </div>
                    {this.state.cartVisible && (
                            <div className="cartDiv Su_cartDiv" >
                                <Cart cartClick={this.cartClick}></Cart>
                            </div>
                        )}
                         
                </div>
                </div>
            </div>
        )
    }
}
